import React from "react";

import { TREAT_IT_URL } from "../../../constants";
import { useLocation, useNavigate } from "react-router-dom";
import AppointmentDateTime from "./AppointmentDateTime";
import { useState } from "react";
import NavStepper from "./NavStepper";

export default function TopNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const currentPath =
    location.pathname.split("/onboarding/eligibility-flow/")[1] || "";

  const handleRouteToWebsite = () => {
    window.location.href = TREAT_IT_URL;
  };
  const showCloseButtonForPaths = [""];

  const handleOnClose = () => {
    navigate("/auth/signin");
  };
  const handleMenuOnClose = () => {
    setIsMenuOpen(false);
  };

  const handleOnBack = () => {
    navigate(-1);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <nav
      className={`${
        isMenuOpen ? "nav-menu-open" : "logo-nav"
      } d-flex flex-column align-items-center pt-0 px-0 position-fixed top-0 w-100`}
    >
      <AppointmentDateTime
        currentPath={currentPath}
        className="w-100 py-1 justify-content-between gap-10 topbar-text"
      />
      {isMenuOpen ? (<><div className="d-flex flex-row align-items-center justify-content-between w-100 px-4">
            <button
              className="bg-transparent p-0 border-0"
              onClick={handleRouteToWebsite}
            >
              <img className="logo p-4 ps-0" src="/images/logo.png" alt="" />
            </button>
            <img
              src="/images/vectors/close-icon-primary.svg"
              alt="close"
              className="google-icon"
              onClick={handleMenuOnClose}
            />
          </div>
        <div className="d-flex flex-column align-items-start justify-content-between px-5 h-100 scroll-menu">
          <div className="d-flex flex-column gap-5 mt-4">
            <a
              href="https://treat-it.clinic/pricing/"
              target="_blank"
              rel="noopener noreferrer"
              className="border-0 bg-transparent text-black fw-bold text-decoration-none fw-bold fs-6"
            >
              {" "}
              Pricing
            </a>
            <a
              href="https://treat-it.clinic/conditions/"
              target="_blank"
              rel="noopener noreferrer"
              className="border-0 bg-transparent text-black fw-bold me-2 me-xl-4 text-decoration-none fw-bold fs-6"
            >
              {" "}
              Conditions
            </a>
          </div>
          <hr className="d-block d-md-none border gray-border my-4 w-100" />
          <div className="h-100 scroll-menu">
          <NavStepper currentPath={currentPath} isTopMenu={true} />
        </div>
        </div>
        </>
      ) : (
        <div className="d-flex flex-row align-items-center justify-content-between w-100 px-5">
          {showCloseButtonForPaths.includes(currentPath) ? (
            <img
              src="/images/vectors/close-icon-primary.svg"
              alt="close"
              className="google-icon"
              onClick={handleOnClose}
            />
          ) : (
            <img
              src="/images/vectors/chevron-right.svg"
              alt="close"
              className="chevron-left"
              onClick={handleOnBack}
            />
          )}
          <button
            className="bg-transparent p-0 border-0"
            onClick={handleRouteToWebsite}
          >
            <img className="logo p-4" src="/images/logo.png" alt="" />
          </button>
          <img
            src="/images/vectors/hamburger.svg"
            alt="close"
            className="menu-icon p-1 rounded-1"
            onClick={toggleMenu}
          />
        </div>
      )}
    </nav>
  );
}
